const customerServiceLinks = [
  {
    'data-test': 'footer-help-home',
    href: '/help',
    text: 'Help home'
  },
  {
    'data-test': 'footer-store-locator',
    href: '/stores',
    text: 'Store locator'
  },
  {
    'data-test': 'footer-your-account',
    href: '/account/login',
    text: 'Your Account'
  },
  {
    'data-test': 'footer-track-your-order',
    href: '/webapp/wcs/stores/servlet/OrderTracking?langId=110&storeId=10151',
    text: 'Track your order'
  },
  {
    'data-test': 'footer-returns-and-refunds',
    href: '/help/returns-and-refunds',
    text: 'Aftersales & returns'
  },
  {
    'data-test': 'footer-delivery-and-collection',
    href: '/help/delivery-and-collection',
    text: 'Delivery & collection'
  },
  {
    'data-test': 'footer-product-recall',
    href: '/events/safety-product-recalls',
    text: 'Product recall'
  },
  {
    'data-test': 'footer-email-sign-up',
    href: 'https://competitions.argos.co.uk/orderconfirmemailsignup/',
    text: 'Email sign up'
  },
  {
    'data-test': 'footer-stay-safe-online',
    href: 'https://www.argos.co.uk/help/stay-safe-online/',
    text: 'Stay safe online'
  }
]

const paymentMethodLinks = [
  {
    'data-test': 'footer-payment-types',
    href: '/help/payment-types',
    text: 'Payment types'
  },
  {
    'data-test': 'footer-gift-cards',
    href: '/help/gift-cards',
    text: 'Gift cards'
  },
  {
    'data-test': 'footer-voucher-codes',
    href: '/events/voucher-discount-codes',
    text: 'Voucher codes'
  },
  {
    'data-test': 'footer-argos-card',
    href: '/help/argos-card',
    text: 'Argos Card'
  }
]

const aftercareLinks = [
  {
    'data-test': 'footer-product-care',
    href: '/help/argos-care',
    text: 'Product care'
  },
  {
    'data-test': 'footer-product-support',
    href: 'http://www.argos-support.co.uk/',
    target: '_blank',
    text: 'Product support'
  }
]

const productInfolinks = [
  {
    'data-test': 'footer-advice-and-inspiration',
    href: '/features/advice-and-inspiration',
    text: 'Advice & inspiration'
  },
  {
    'data-test': 'footer-product-reviews',
    href: '/features/product-review',
    text: 'Product reviews'
  }
]

const otherSitesLinks = [
  {
    'data-test': 'footer-argoscareers-com',
    href: 'http://argos.careers/',
    text: 'Argoscareers.com'
  },
  {
    'data-test': 'footer-argos-ie',
    href: 'https://www.argos.ie',
    target: '_blank',
    text: 'Argos.ie'
  },
  {
    'data-test': 'footer-argos-spares',
    href: 'http://www.argosspares.co.uk/',
    target: '_blank',
    text: 'Argos Spares'
  },
  {
    'data-test': 'footer-argos-pet-insurance',
    href: 'https://www.argospetinsurance.co.uk/?utm_source=argos.co.uk&utm_medium=referral&utm_campaign=ARG_footer',
    target: '_blank',
    text: 'Pet Insurance'
  }
]

const aboutLinks = [
  {
    'data-test': 'footer-about-us',
    href: 'https://www.about.sainsburys.co.uk/great-products-and-services/argos',
    target: '_blank',
    text: 'About us'
  },
  {
    'data-test': 'footer-argos-for-business',
    href: 'https://argosforbusiness.co.uk/',
    target: '_blank',
    text: 'Argos for Business'
  },
  {
    'data-test': 'footer-press-enquiries',
    href: 'https://www.about.sainsburys.co.uk/news/media-enquiries',
    target: '_blank',
    text: 'Press enquiries'
  },
  {
    'data-test': 'footer-nectar-at-argos',
    href: 'https://www.argos.co.uk/help/nectar/',
    target: '_blank',
    text: 'Nectar at Argos'
  }
]

const primaryButtons = [
  {
    'data-test': 'footer-m-help-home',
    href: '/help',
    text: 'Help'
  },
  {
    'data-test': 'footer-m-your-account',
    href: '/account/login',
    text: 'Your Account'
  },
  {
    'data-test': 'footer-m-store-locator',
    href: '/stores',
    text: 'Store Locator'
  },
  {
    'data-test': 'footer-m-argos-card',
    href: '/help/argos-card',
    text: 'Argos Card'
  }
]

const cardLogos = [
  {
    alt: 'Argos card',
    src: 'footer-argos-card'
  },
  {
    alt: 'Visa card',
    src: 'footer-visa'
  },
  {
    alt: 'Master card',
    src: 'footer-mastercard'
  },
  {
    alt: 'Maestro card',
    src: 'footer-maestro'
  },
  {
    alt: 'American Express card',
    src: 'footer-american-express'
  },
  {
    alt: 'Paypal',
    src: 'footer-paypal'
  },
  {
    alt: 'Love 2 Shop Card',
    src: 'Love2Shop'
  },
  {
    alt: 'Argos Gift Card',
    src: 'ArgosGiftCard'
  },
  {
    alt: 'For Business Card',
    src: 'ForBusinessCard'
  },
  {
    alt: 'One4All Card',
    src: 'One4All'
  },
  {
    alt: 'Nectar Card',
    src: 'Nectar'
  }
]

export {
  customerServiceLinks,
  paymentMethodLinks,
  aftercareLinks,
  productInfolinks,
  otherSitesLinks,
  aboutLinks,
  primaryButtons,
  cardLogos
}
